export default __webpack_public_path__ + "static/media/comEcole.9dbda0a1.png";